import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Button, Checkbox, Input } from "nlib/ui";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import CustomPromptTypes from "const/CustomPromptTypes";
import React, { useCallback, useRef } from "react";
import useShowCommonModal from "hooks/useShowCommonModal";

const PROMPT_MAX_LENGTH = 5000;

const ADDITIONAL_PROMPT_MAX_LENGTH = 2000;

const { ADDITIONAL } = CustomPromptTypes;

const EditPrompt = (props) => {
  const {
    disabled,
    type,
    value,
    index,
    label,
    description,
    placeholder,
    removable,
    focused,
    onChange,
    onRemove
  } = props;

  const { uiTexts, messages } = useSelector(getTextsData);

  const { text = "", active = false } = value;

  const inputRef = useRef(null);

  const showCustomModal = useShowCommonModal();

  const additionalPrompt = type.startsWith(ADDITIONAL);

  const maxLength = additionalPrompt ? ADDITIONAL_PROMPT_MAX_LENGTH : PROMPT_MAX_LENGTH;

  const textTooLong = text.length > maxLength;

  const handleChange = useCallback((newValue) => {
    onChange(type, { active, text: newValue });
  }, [onChange, type, active]);

  const handleChangeActive = useCallback((newValue) => {
    onChange(type, { active: newValue, text });
  }, [onChange, type, text]);

  const handleRemoveClick = useCallback(async() => {
    const result = await showCustomModal({
      text: messages.removeCustomPrompt,
      confirm: true,
      okButtonText: uiTexts.remove
    });

    if (result) onRemove(index);
  }, [index, showCustomModal, messages, uiTexts, onRemove]);

  return (
    <div className={Css.editPrompt}>
      <div className={Css.header}>
        <Checkbox
          toggle
          value={active}
          label={label}
          onChange={handleChangeActive} />
        {removable && (
          <Button
            small danger light
            title={uiTexts.remove}
            value={index} onClick={handleRemoveClick}>
            <Icons.Trash />
          </Button>
        )}
      </div>
      {description && (
        <div className={Css.description}>{description}</div>
      )}
      {active && (
        <div className={Css.textWrap}>
          <Input
            multiline
            autoFocus={focused}
            inputRef={inputRef}
            error={textTooLong}
            disabled={disabled}
            placeholder={placeholder}
            maxLength={maxLength}
            value={text}
            onChange={handleChange} />
        </div>
      )}
    </div>
  );
};

export default EditPrompt;
